/* DD Vending Partner Form — wizard a 4 step, invia a
   supabase/functions/partner-submit (stessa function usata da
   dd-repo/src/pages/Partner.tsx per le candidature "Automatenstelle
   anbieten"; tabella partner_applications, email a vending@deckdynastie.com). */
(function () {
  'use strict';

  var SUPABASE_URL = 'https://api.deckdynastie.com';
  var SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpva3dsZmdmdWxscmt2dHRiZG12Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM4NDI2NzYsImV4cCI6MjA4OTQxODY3Nn0.1v3LYAkKteIKvCpSHQoSPY1cBIYs-Eky8XZA2p9ZaQY';
  var ENDPOINT = SUPABASE_URL + '/functions/v1/partner-submit';
  var STEP_LABELS = {
    1: 'Schritt 1 von 4 — Kontakt',
    2: 'Schritt 2 von 4 — Dein Interesse',
    3: 'Schritt 3 von 4 — Deine Location',
    4: 'Schritt 4 von 4 — Budget & Absenden'
  };

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    document.querySelectorAll('[data-dd-vp-wizard]').forEach(function (wizard) {
      var form = wizard.querySelector('[data-dd-vp-form]');
      if (!form) return;

      var steps = Array.prototype.slice.call(wizard.querySelectorAll('[data-dd-vp-step]'));
      var dots = wizard.querySelectorAll('[data-step-dot]');
      var stepLabel = wizard.querySelector('[data-dd-vp-step-label]');
      var errorSlot = form.querySelector('[data-dd-vp-alert-slot="error"]');
      var successSlot = form.querySelector('[data-dd-vp-alert-slot="success"]');
      var submitBtn = form.querySelector('[data-dd-vp-submit]');
      var submitTextEl = submitBtn ? submitBtn.querySelector('.btn-text') : null;
      var tierSelect = form.querySelector('[name="tier_interest"]');
      var locationRadios = form.querySelectorAll('[data-dd-vp-location-radio]');
      var currentStep = 1;

      // Vorauswahl aus dem Tier-CTA-Link (?interesse=brand_partner#dd-vp-form).
      if (tierSelect) {
        var params = new URLSearchParams(window.location.search);
        var interesse = params.get('interesse');
        if (interesse && form.querySelector('[name="tier_interest"] option[value="' + interesse + '"]')) {
          tierSelect.value = interesse;
        }
      }

      function stepPanel(n) {
        return steps.filter(function (s) { return s.getAttribute('data-dd-vp-step') === String(n); })[0];
      }

      function showStep(n) {
        currentStep = n;
        steps.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-dd-vp-step') !== String(n);
        });
        dots.forEach(function (dot) {
          var i = Number(dot.getAttribute('data-step-dot'));
          dot.removeAttribute('data-active');
          dot.removeAttribute('data-done');
          if (i === n) dot.setAttribute('data-active', '');
          else if (i < n) dot.setAttribute('data-done', '');
        });
        if (stepLabel) {
          if (n === 3) {
            var checkedNow = form.querySelector('[data-dd-vp-location-radio]:checked');
            var v = checkedNow ? checkedNow.value : '';
            if (v === 'find_for_me' || v === 'searching_myself') stepLabel.textContent = 'Schritt 3 von 4 — Deine Wunschregion';
            else if (v === 'info_only') stepLabel.textContent = 'Schritt 3 von 4 — Fast geschafft';
            else stepLabel.textContent = STEP_LABELS[3];
          } else {
            stepLabel.textContent = STEP_LABELS[n] || '';
          }
        }
        var panel = stepPanel(n);
        if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      function validateStep(n) {
        var panel = stepPanel(n);
        if (!panel) return true;
        var invalid = null;
        panel.querySelectorAll('input[required], select[required]').forEach(function (el) {
          if (invalid) return;
          // Radio-Gruppen: nur einmal prüfen, überspringen wenn schon eine Option gewählt ist.
          if (el.type === 'radio') {
            var group = panel.querySelectorAll('input[name="' + el.name + '"]');
            var anyChecked = Array.prototype.some.call(group, function (r) { return r.checked; });
            if (!anyChecked) invalid = invalid || group[0];
            return;
          }
          if (!el.checkValidity()) invalid = invalid || el;
        });
        if (invalid) {
          invalid.reportValidity ? invalid.reportValidity() : invalid.focus();
          return false;
        }
        return true;
      }

      function updateConditionalBlocks() {
        var checked = form.querySelector('[data-dd-vp-location-radio]:checked');
        var value = checked ? checked.value : '';
        wizard.querySelectorAll('[data-dd-vp-block="has_location"]').forEach(function (el) { el.hidden = value !== 'has_location'; });
        wizard.querySelectorAll('[data-dd-vp-block="searching"]').forEach(function (el) { el.hidden = !(value === 'find_for_me' || value === 'searching_myself'); });
        wizard.querySelectorAll('[data-dd-vp-block="info_only"]').forEach(function (el) { el.hidden = value !== 'info_only'; });
      }

      locationRadios.forEach(function (radio) {
        radio.addEventListener('change', updateConditionalBlocks);
      });
      updateConditionalBlocks();

      wizard.querySelectorAll('[data-dd-vp-next]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!validateStep(currentStep)) return;
          if (currentStep === 2) updateConditionalBlocks();
          showStep(Math.min(currentStep + 1, steps.length));
        });
      });
      wizard.querySelectorAll('[data-dd-vp-back]').forEach(function (btn) {
        btn.addEventListener('click', function () { showStep(Math.max(currentStep - 1, 1)); });
      });

      function setAlert(slot, message) {
        hideAlerts();
        if (!slot) return;
        var textEl = slot.querySelector('[data-dd-vp-alert-text]');
        if (textEl) textEl.textContent = message;
        slot.hidden = false;
        slot.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      function hideAlerts() {
        if (errorSlot) errorSlot.hidden = true;
        if (successSlot) successSlot.hidden = true;
      }

      function setLoading(isLoading) {
        if (!submitBtn) return;
        submitBtn.disabled = isLoading;
        if (submitTextEl) {
          submitTextEl.textContent = isLoading
            ? (submitBtn.getAttribute('data-loading-label') || 'Wird gesendet…')
            : (submitBtn.getAttribute('data-label') || submitTextEl.textContent);
        }
        // Der native `hover-button`-Web-Component (theme.js) setzt bei jedem
        // submit-Event selbst aria-busy="true" und erwartet ein volles
        // Seiten-Reload (pageshow-Event), um es wieder zu entfernen. Da wir
        // hier per fetch senden und nie neu laden, blieb der Button sonst für
        // immer im Lade-Spinner hängen.
        if (!isLoading) submitBtn.removeAttribute('aria-busy');
      }

      function fieldValue(name) {
        var el = form.querySelector('[name="' + name + '"]');
        if (!el) return '';
        return el.value ? el.value.trim() : '';
      }

      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();

        if (!validateStep(4)) return;
        if (form.querySelector('[name="honeypot"]').value) return;

        var hasLocationChecked = form.querySelector('[data-dd-vp-location-radio]:checked');

        var payload = {
          company_name: fieldValue('company_name'),
          contact_name: fieldValue('contact_name'),
          email: fieldValue('email'),
          phone: fieldValue('phone'),
          partnership_type: 'Automatenstelle anbieten',
          tier_interest: fieldValue('tier_interest') || null,
          has_location: hasLocationChecked ? hasLocationChecked.value : null,
          message: fieldValue('message'),
          honeypot: '',
          details: {
            address: fieldValue('address'),
            plz: fieldValue('plz'),
            city: fieldValue('city'),
            location_type: fieldValue('location_type'),
            foot_traffic: fieldValue('foot_traffic'),
            ownership: fieldValue('ownership'),
            target_city: fieldValue('target_city'),
            radius_km: fieldValue('radius_km'),
            budget_range: fieldValue('budget_range'),
            timeline: fieldValue('timeline')
          }
        };

        setLoading(true);
        hideAlerts();

        fetch(ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + SUPABASE_ANON_KEY,
            'apikey': SUPABASE_ANON_KEY
          },
          body: JSON.stringify(payload)
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (result) {
            if (!result.ok || result.data.error) {
              if (result.data && result.data.error === 'email_already_registered') {
                setAlert(errorSlot, result.data.message_de || 'Diese E-Mail wurde bereits verwendet.');
              } else if (result.data && result.data.error === 'rate_limited') {
                setAlert(errorSlot, 'Zu viele Anfragen. Bitte versuche es in ein paar Minuten erneut.');
              } else {
                throw new Error('submit_failed');
              }
              return;
            }
            form.reset();
            updateConditionalBlocks();
            showStep(1);
            setAlert(successSlot, 'Danke! Wir melden uns in Kürze bei dir.');
          })
          .catch(function () {
            setAlert(errorSlot, 'Etwas ist schiefgelaufen. Bitte versuche es später erneut.');
          })
          .finally(function () { setLoading(false); });
      });

      showStep(1);
    });
  });
})();
